import { JSONContent } from '@tiptap/core';
import { Widget } from 'types/widget.types';

export interface TextBasedWidgetData extends Widget {
  proseMirrorData: JSONContent;
}

export type TextTagStyleConfig = {
  fontFamily: string;
  isBold: boolean;
  isItalic: boolean;
  isUnderline?: boolean;
  fontSize: number;
  color: string;
  lineHeight?: string;
};

export enum TextWidgetTag {
  H1 = 'heading 1',
  H2 = 'heading 2',
  H3 = 'heading 3',
  H4 = 'heading 4',
  H5 = 'heading 5',
  H6 = 'heading 6',
  Paragraph = 'paragraph',
}

// Text with effect styling is restricted to the "figure" tag.
export enum TextWidgetExceptionTag {
  Figure = 'Figure',
}

export enum WidgetState {
  // widget is not selected
  Default = 'default',
  // widget is selected but not in text editable mode
  Active = 'active',
  // widget is selected and in text editable mode
  Edit = 'edit',
}

export type ListAttributes = {
  bold: boolean;
  italic: boolean;
  fontSize?: string;
  fontFamily?: string;
  color?: string;
};
